import { Card } from "@blueprintjs/core";
import { IDataTableColumn, useGridState } from "nsitools-react";
import * as React from "react";

import { DogCompetitionResultGridDto } from "../../../../../../api";
import { useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import { CustomDataTable } from "../../../../../../components";

export interface IDogResultCardProps {
  data: DogCompetitionResultGridDto[];
}

export const DogResultCard: React.FunctionComponent<IDogResultCardProps> = (props) => {
  const { t } = useTl();

  const { data } = props;

  const tableState = useGridState<any>({
    serverMode: false,
    enablePagination: false,
    enableFilter: false,
    sortKeys: { date: "ASC" },
    data: data,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Competition),
        fieldName: "competition",
      },
      {
        header: () => t(ETLCodes.Result),
        fieldName: "result",
      },
    ],
    [t]
  );
  return (
    <Card>
      <CustomDataTable tableState={tableState} columns={columns} renderNoData={<></>} />
    </Card>
  );
};
